import React from "react";
import AdminLayout from "./AdminLayout";
import ExpenseManagement from "./ExpenseManagement";


function Projects() {
    return (
        <AdminLayout>
            <ExpenseManagement />
        </AdminLayout>
    );
}

export default Projects;
